<template>
  <div class="pre-checkout-sidebar-register">
    <slot name="error"></slot>
    <div class="pre-checkout-sidebar-register-title">
      <span class="pre-checkout-sidebar-register-title-text">
        Δημιουργία λογαριασμού
      </span>
    </div>
    <form class="pre-checkout-sidebar-register-form" accept-charset="utf-8" method="post">
      <div class="form-group dioptra-input-wrapper">
        <input id="mail"
               v-model="email"
               class="form-control dioptra-input-field"
               name="mail"
               placeholder="Το email σου"
               required
               type="email"
        >
        <label class="customer-register-form-label dioptra-input-label"
               for="mail"
        >Email</label>
      </div>
      <div class="form-group dioptra-input-wrapper">
        <input id="drowssap"
               ref="passwordInput"
               v-model="password"
               class="form-control dioptra-input-field password-class"
               name="drowssap"
               placeholder="Κωδικός"
               required
               type="password"
        >
        <label class="customer-register-form-label dioptra-input-label"
               for="drowssap"
        >Password</label>
        <span class="customer-toggle-password" @click="togglePasswordVisibility">
          <img alt="Show password"
               title="Show password"
               class="img-fluid"
               height="16"
               :src="passwordImage"
               width="24"
          />
        </span>
      </div>
      <div class="form-group dioptra-input-wrapper">
        <input id="password_retype"
               ref="passwordRetypeInput"
               v-model="passwordRetype"
               class="form-control dioptra-input-field password-class"
               name="password_retype"
               placeholder="Επανάληψη κωδικού"
               required
               type="password"
        >
        <label class="customer-register-form-label dioptra-input-label"
               for="password_retype"
        >Password</label>
        <span class="customer-toggle-password" @click="togglePasswordRetypeVisibility">
          <img alt="Show password"
               title="Show password"
               class="img-fluid"
               height="16"
               :src="passwordRetypeImage"
               width="24"
          />
        </span>
      </div>
      <button class="pre-checkout-sidebar-body-form-button submit-btn" name="register" type="submit" value="register">
        <span>Εγγραφή</span>
      </button>
    </form>
    <div class="pre-checkout-sidebar-register-actions">
      <div class="pre-checkout-sidebar-register-actions-return">
        <button class="pre-checkout-sidebar-register-actions-return-button"
                name="return"
                value="return"
                @click="onReturnBackClick"
        >
          <span class="pos-rel pre-checkout-sidebar-register-actions-return-button-text">Επιστροφή</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PreCheckoutSidebarRegister',
  data () {
    return {
      email: '',
      password: '',
      passwordRetype: '',
      passwordVisible: false,
      passwordRetypeVisible: false
    }
  },
  computed: {
    passwordImage () {
      return this.passwordVisible ? '/ui/main/img/eye_close.svg' : '/ui/main/img/eye_open.svg'
    },
    passwordRetypeImage () {
      return this.passwordRetypeVisible ? '/ui/main/img/eye_close.svg' : '/ui/main/img/eye_open.svg'
    }
  },
  methods: {
    togglePasswordVisibility () {
      const passwordInput = this.$refs.passwordInput
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password'
      this.passwordVisible = !this.passwordVisible
    },
    togglePasswordRetypeVisibility () {
      const passwordInput = this.$refs.passwordRetypeInput
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password'
      this.passwordRetypeVisible = !this.passwordRetypeVisible
    },
    onReturnBackClick () {
      this.$emit('return-back-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.pre-checkout-sidebar-register-form {
  margin-bottom: 30px;
}
.form-control {
  border: 1px solid #231F20;
  border-radius: unset;
  padding: 10px 25px;
  font-weight: 400;
  color: #231F20;
}
.pre-checkout-sidebar-register {
  padding-left: 40px;
  padding-right: 40px;
  // @media screen and (max-width: 767px) {
  //   padding-top: 150px;
  // }
}
.pre-checkout-sidebar-body-form-button {
  font-size: 19px;
  border-radius: unset;
  width: 100%;
  @media screen and (max-width: 767px) {
    font-size: 17px;
  }
}
.pre-checkout-sidebar-register-title {
  margin-bottom: 30px;
}
.pre-checkout-sidebar-register-title-text {
  font-size: 24px;
  font-weight: 700;
  color: #231F20;
}
.pre-checkout-sidebar-register-actions {
  display: grid;
  gap: 100px;
  align-items: center;
  align-content: space-between;
}
.pre-checkout-sidebar-register-actions-return {
  display: grid;
  gap: 14px;
}
.pre-checkout-sidebar-register-actions-return-button {
  width: 100%;
  background: #fff;
  color: #231F20;
  font-size: 15px;
  border: unset;
  text-align: start;
}
.pre-checkout-sidebar-register-actions-return-button-text {
  display: flex;
  align-items: center;
  padding-left:25px;
  &:before {
    content:"";
    left:0;
    position: absolute;
    top:50%;
    transform: translateY(-50%) rotate(-45deg);
    width: 14px;
    height: 14px;
    border-top: 2px solid var(--prime1);
    border-left: 2px solid var(--prime1)
  }
}
</style>
